// Two screens use it, each with half the targets. The fields are React comboboxes:
// changing what they offer or require means new props and a remount.
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["template", "templateBlock", "materials", "date", "taskFields"]

  connect() {
    this.route = this.data.get("route")
    this.choose()
  }

  choose() {
    const picked     = this.element.querySelector('input[name="plan_source"]:checked')
    const byTemplate = picked ? picked.value === "template" : false

    if (this.hasTemplateBlockTarget) {
      this.templateBlockTarget.hidden = !byTemplate
      this._setRequired(this.templateBlockTarget, byTemplate)
    }

    if (this.hasMaterialsTarget) this._setRequired(this.materialsTarget, byTemplate)
    if (this.hasDateTarget)      this.dateTarget.required = byTemplate
    if (this.hasTaskFieldsTarget) this._setAside(this.taskFieldsTarget, byTemplate)

    if (!byTemplate) this._clearTemplate()
  }

  siteChange(event) {
    if (!this.route || !this.hasMaterialsTarget) return

    const siteId = event.target.value
    if (!siteId) return this._setOptions(this.materialsTarget, [])

    fetch(`${this.route}?site_id=${siteId}`, {
      credentials: "same-origin",
      headers:     { "X-Requested-With": "XMLHttpRequest" }
    })
      .then(response => (response.ok ? response.json() : []))
      .then(materials => this._setOptions(this.materialsTarget, materials))
      .catch(() => this._setOptions(this.materialsTarget, []))
  }

  // The required flags come off too: a hidden required input blocks submission in silence.
  _setAside(fieldset, aside) {
    fieldset.hidden   = aside
    fieldset.disabled = aside

    fieldset.querySelectorAll("[required]").forEach(field => {
      field.dataset.wasRequired = "true"
      if (aside) field.required = false
    })

    if (!aside) {
      fieldset.querySelectorAll("[data-was-required]").forEach(field => { field.required = true })
    }
  }

  _clearTemplate() {
    if (!this.hasTemplateTarget || !this.templateTarget.value) return

    this.templateTarget.value = ""
    this._writeProps(this.templateBlockTarget, props => ({ ...props, value: null }))
  }

  _setOptions(wrapper, options) {
    this._writeProps(wrapper, props => ({ ...props, options, value: [] }))
  }

  // Only the block's first combobox: the others carry their own rule.
  _setRequired(wrapper, required) {
    this._writeProps(wrapper, props => ({ ...props, required }))
  }

  _writeProps(wrapper, change) {
    const container = wrapper.querySelector("[data-react-class]")
    if (!container || !container.dataset.reactProps) return

    container.dataset.reactProps = JSON.stringify(change(JSON.parse(container.dataset.reactProps)))
    reloadReact(wrapper)
  }
}
